import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import "rxjs/Rx";

@Injectable()
export class SendEmailService {
  constructor(private http: HttpClient) { }

  /**
   * @description Takes in the person_id of the student that was submitted
   * @requires PERSON_ID
   * @returns Error if any.
   */
  requestSubmitted(studentName: string) {
    return this.http.post(`/api/SendEmail/requestSubmitted`, { studentName: studentName }, {
      observe: "response"
    });
  }

  /**
   * @description Takes in the template name and returns details per environment
   * @requires EMAIL_TEMPLATE_NM
   * @returns SENDER_ADDR, SUBJECT_TXT
   */
  getEmailTemplateByNm(emailTemplateNm: string) {
    return this.http.get(`/api/SendEmail/getEmailTemplateByNm`, {
      params: { type: emailTemplateNm },
      responseType: "json"
    });
  }
}



// WEBPACK FOOTER //
// ./client/views/services/sendemail.service.ts